import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { PhotoSection, ContactSection, EmailSection, labelCls } from "./ProfileSections";
import ReferralCard from "@/components/ReferralCard";
import { isPlaceholderEmail } from "@/lib/email";
import { Repeat, Building2 } from "lucide-react";

export default function MyProfile() {
  const { user, refresh } = useAuth();
  const nav = useNavigate();

  return (
    <div className="grid lg:grid-cols-[1fr_minmax(0,380px)] gap-8 lg:gap-12" data-testid="my-profile">
      <div className="border border-white/10 bg-[#0A0A0A] p-6 md:p-8 space-y-8">
        <div>
          <div className="overline mb-1">Account</div>
          <h2 className="font-serif text-2xl md:text-3xl">Your details</h2>
        </div>
        <PhotoSection user={user} refresh={refresh}/>
        <ContactSection user={user} refresh={refresh}/>
        <EmailSection user={user} refresh={refresh}/>
      </div>

      <div className="space-y-6">
        <div>
          <div className={labelCls}>Shortcuts</div>
          <div className="grid grid-cols-2 lg:grid-cols-1 gap-3">
            <button data-testid="customer-series" onClick={() => nav("/series")}
              className="bg-white text-[#050505] border border-black/8 hover:border-[#D4AF37] transition p-5 text-left group">
              <Repeat size={16} className="mb-3 text-[#71717A] group-hover:text-[#D4AF37] transition-colors"/>
              <div className="overline mb-1">Recurring</div>
              <div className="font-[Outfit] text-lg tracking-tight">My series →</div>
            </button>
            <button data-testid="customer-corporate" onClick={() => nav("/corporate")}
              className="bg-white text-[#050505] border border-black/8 hover:border-[#D4AF37] transition p-5 text-left group">
              <Building2 size={16} className="mb-3 text-[#71717A] group-hover:text-[#D4AF37] transition-colors"/>
              <div className="overline mb-1">Business</div>
              <div className="font-[Outfit] text-lg tracking-tight">Corporate accounts →</div>
            </button>
          </div>
        </div>
        {user?.email && !isPlaceholderEmail(user.email) && <ReferralCard email={user.email}/>}
      </div>
    </div>
  );
}
